var map = {
	"./anne-kath.png": 987,
	"./bard-johansen.png": 498,
	"./christine-koht.png": 176,
	"./espen-eckbo.png": 736,
	"./henriette-steenstrup.png": 372,
	"./jon-almaas.png": 609,
	"./leo-ajkic.png": 111,
	"./linn-skaber.png": 616,
	"./morten-ramm.png": 877,
	"./pia-tjelta.png": 49
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 604;